import { dateFormat } from 'common/helpers/dateHelper';

const DeliveryDate = (props) => {
  const { order, settings } = props;
  if (
    order.selectedShippingOptions &&
    order.selectedShippingOptions.requestedDeliveryDate
  ) {
    return (
      <span>
        <strong>Delivery date</strong>
        <br />
        {dateFormat(
          order.selectedShippingOptions.requestedDeliveryDate,
          settings
        )}
      </span>
    );
  }
  return null;
};

export default DeliveryDate;
